import { AmbassadorMedal } from 'app/design/icons/ambassador-medal';
import { SuperSharerMedal } from 'app/design/icons/super-sharer-medal';
import { theme } from './shared';

export function ProfileBadge({
  showSuperPartageur,
  viewedProfileIsAmbassador,
}: {
  showSuperPartageur: boolean;
  viewedProfileIsAmbassador: boolean;
}) {
  if (viewedProfileIsAmbassador) {
    return (
      <AmbassadorMedal
        width={55}
        height={55 * (60 / 57)}
        style={{
          position: 'absolute',
          bottom: -theme.spacing['spacing.general.x4'],
          right: -theme.spacing['spacing.general.x2'],
        }}
      />
    );
  }
  if (!showSuperPartageur) return null;
  return (
    <SuperSharerMedal
      width={55}
      height={55 * (69 / 57)}
      style={{
        position: 'absolute',
        bottom: -theme.spacing['spacing.general.x5'],
        right: -theme.spacing['spacing.general.x3'],
      }}
    />
  );
}
